let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9FyNI")).then(() => parcelRequire('5WJh7'));